<template>
  <div class="robot-dialog">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogForm.show"
      title="新建计划"
      width="580px"
      :close-on-click-modal="false"
    >
      <div>
        <el-form :model="form" :rules="rules" :show-message="false" :inline-message="false">
          <el-form-item label="计划名称" prop="planName">
            <el-input v-model="form.planName" placeholder="请输入计划名称" maxlength="50" :disabled="!dialogForm.editor" show-word-limit />
          </el-form-item>
          <el-form-item label="机器人名称" prop="robotName" class="mr-top">
            <el-select v-model="form.robotName" placeholder="请选择需要的机器人名称" :disabled="!dialogForm.editor" style="width:250px;">
              <el-option
                v-for="(item, index) in robotList"
                :key="index"
                :label="item.taskName"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="计划频次" prop="frequency" class="mr-top">
            <el-radio-group v-model="form.frequency" :disabled="!dialogForm.editor">
              <el-radio :label="0">单次</el-radio>
              <el-radio :label="1">每天</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-show="form.frequency === 0" label="选择日期" prop="selectDate" class="mr-top">
            <el-date-picker
              v-model="form.selectDate"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :disabled="!dialogForm.editor"
              type="date"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item v-show="form.frequency === 1" label="选择日期" prop="selectDateArr" class="mr-top">
            <el-date-picker
              v-model="form.selectDateArr"
              type="daterange"
              :disabled="!dialogForm.editor"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>

          <el-form-item label="运行时间" prop="elapsedTime" class="mr-top">
            <el-time-picker
              v-model="form.elapsedTime"
              :disabled="!dialogForm.editor"
              value-format="HH:mm"
              format="HH:mm"
              range-separator=":"
              placeholder="请选择当日运行时间"
            />
          </el-form-item>
        </el-form>
        <span class="prompt mr-top">温馨提示：机器人将会根据选择时间运行</span>
      </div>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogForm: {
      type: Object,
      required: true
    },
    robotList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      form: {
        planName: '',
        robotName: '',
        frequency: 0,
        selectDate: '',
        selectDateArr: [],
        elapsedTime: ''
      },
      rules: {
        planName: [
          {
            required: true
          }
        ],
        robotName: [
          {
            required: true
          }
        ],
        frequency: [
          {
            required: true
          }
        ],
        selectDate: [
          {
            required: true
          }
        ],
        selectDateArr: [
          {
            required: true
          }
        ],
        elapsedTime: [
          {
            required: true
          }
        ]
      }
    }
  },
  // watch: {
  //   'form.frequency': function(val) {
  //     console.log('val====', val)
  //     if (val === 0) {
  //       this.form.selectDate = ''
  //     } else {
  //       this.form.selectDateArr = []
  //     }
  //   }
  // },
  methods: {
    onShow(form) {
      this.form = {
        planName: form.scheduleName,
        robotName: form.taskName,
        frequency: form.taskRunningPlan
      }
      // taskRunningPlan为1则为每天运行
      this.$set(this.form, 'elapsedTime', new Date())
      if (form.taskRunningPlan === 1) {
        this.$set(this.form, 'selectDateArr', new Date())
        this.form.selectDateArr = [form.taskDailyStart, form.taskDailyEnd]
        this.form.elapsedTime = form.taskDailyTime
      } else {
        this.$set(this.form, 'selectDate', new Date())
        this.form.selectDate = form.taskRunDateTime
        this.form.elapsedTime = form.taskRunDateTime.substring(form.taskRunDateTime.length - 8)
      }
    },
    // 取消
    cancel() {
      this.$emit('planCancel')
      this.reset()
    },
    // 初始化
    reset() {
      this.form = {
        planName: '',
        robotName: '',
        frequency: 0,
        selectDate: '',
        selectDateArr: [],
        elapsedTime: ''
      }
    },
    // 下一步
    nextStep() {
      if (this.dialogForm.editor) {
        if (!this.form.planName.trim()) {
          this.$message.warning('请输入计划名称')
          return
        }
        if (!this.form.robotName) {
          this.$message.warning('请选择需要的机器人名称')
          return
        }
        if (this.form.frequency === 0) {
          if (!this.form.selectDate) {
            this.$message.warning('请选择日期')
            return
          }
        } else {
          if (this.form.selectDateArr.length !== 2) {
            this.$message.warning('请选择日期')
            return
          }
        }
        if (!this.form.elapsedTime) {
          this.$message.warning('请选择当日运行时间')
          return
        }
      }
      this.$emit('nextStep', this.form)
    }
  }
}
</script>
<style lang="scss">
.robot-dialog {
  .el-form-item__label {
    float: none; // 取消label左浮动
    word-break: break-word; // 支持单词截断换行
  }
  .mr-top {
    margin-top: 10px;
  }
  .prompt{
    width: 100%;
    height: 36px;
    border-radius: 4px;
    background: linear-gradient(135deg,#e9f3fe, #fdfeff);
    color: #333333;
    font-size: 14px;
    line-height: 36px;
    display: inline-block;
    padding-left: 10px;
    font-weight: 500;
  }
}

</style>
